// extracted by mini-css-extract-plugin
export default {"contentWrapper":"App_contentWrapper__go5Q2","container":"App_container__4L7Vo"};